import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Model} from '../../app.model';
import {CompanyService} from '../company.service';
import {observable, runInAction} from 'mobx';
import {ConfirmationService, MessageService} from 'primeng/api';
import {I18NextService} from 'angular-i18next';
import {HttpClient} from '@angular/common/http';
import {AutorunComponent} from '@myshared/autorun.component';
import {AuthService} from '../../auth/auth.service';
import {Contact} from '../company.model';
import {FormEmitter} from "../../forms/form.component";

@Component({
    selector: 'app-contact-details',
    templateUrl: './contact-details.component.html',
    styleUrls: [],
    standalone: false
})
export class ContactDetailsComponent extends AutorunComponent implements OnInit {

  public isAdmin: boolean;
  public userIsActive: boolean;
  public isMypascomDisabled: boolean;
  public hasPhoneNumber: boolean;
  public contact: Contact;

  @observable public contactId: string;
  @observable public loggedInUser: boolean;

  constructor(
    private m: Model,
    private i18next: I18NextService,
    private httpClient: HttpClient,
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) {
    super();
  }

  ngOnInit() {
    this.route.paramMap.subscribe(r => {
      const contactId = r.get('contactId');

      runInAction(() => {
        this.contactId = contactId;
      });
    });

    this.autorun(() => {
      if (!this.contactId) {
        return;
      }
      this.isAdmin = this.m.account.isMypascomAdmin;
      this.hasPhoneNumber = this.m.account.keycloakUser.hasPhoneNumber;
      runInAction(() => {
        this.loggedInUser = +this.m.account.currentUser.id === +this.contactId;
      });

      if (!this.isAdmin && !this.loggedInUser) {
        this.router.navigate(['/']);
        return;
      }

      this.searchUser();
    });

    this.companyService.refresh(true);
  }

  onSubmit(form: FormEmitter<Contact>) {
    const contact = form.data;
    contact.id = this.contact.id

    if (this.loggedInUser) {
      // Cant change own access level
      contact.mypascom_account = this.contact.mypascom_account;
    }

    if (this.loggedInUser && contact.email !== this.m.account.currentUser.email) {
      this.confirmationService.confirm({
        message: this.i18next.t('update_user_confirm_message') as string,
        header: this.i18next.t('update_user_confirm_title') as string,
        key: 'change_userdata_confirm',
        accept: () => this.saveUser(contact)
      });
    } else {
      this.saveUser(contact);
    }
  }

  private saveUser(c: Contact) {
    this.companyService.updateContact(c).subscribe(
      () => {
        this.companyService.refresh(true);
        this.messageService.add({severity: 'success',
          summary: this.i18next.t('contact_saved') as string});
        // If the logged-in user changes their own email address, they will need to log in again.
        if (this.loggedInUser && c.email !== this.m.account.currentUser.email) {
          this.authService.logout();
        } else {
          this.router.navigate(['/company/contacts/' + (this.contactId ?? '')]);
        }
    });
  }

  public back() {
    window.history.back();
  }

  public get accountManagerUrl() {
    return this.authService.oidcAuthority + '/account/';
  }

  private searchUser() {
    const contacts = this.m.company.company.contacts;
    if (this.contactId && contacts.length > 0) {
      this.contact = contacts.find((x) => +x.id === +this.contactId);

      if (this.contact) {
        this.userIsActive = this.contact.active;
        this.isMypascomDisabled = this.contact.mypascom_account.toLowerCase() === 'disabled';
      }
    }
  }
}
